var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDepositAppIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 181,
    height: 148,
    viewBox: "0 0 181 148",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_29963_370718)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.6996 143.182C46.242 146.206 53.4263 147.857 60.6329 147.985C79.8363 148.325 88.5987 142.705 117.017 144.619C121.871 144.946 126.66 146.075 131.517 146.35C160.789 148.009 184.833 114.551 180.491 75.392C178.293 55.5687 166.552 38.0028 151.37 25.0682C51.0222 -60.4261 -61.4941 96.399 39.6996 143.182Z",
    fill: "#EEF4FB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42 52.8953C42 52.3522 42.2959 51.8522 42.7721 51.5909L90.5085 25.3947C90.9562 25.149 91.4986 25.1501 91.9453 25.3975L139.233 51.5898C139.706 51.8519 140 52.3503 140 52.8914V55.5121C140 56.3338 139.334 57 138.512 57H43.4879C42.6662 57 42 56.3338 42 55.5121V52.8953Z",
    fill: "#166BCD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.9707 56.9966L91.2149 31.0918L137.031 56.9966H44.9707Z",
    fill: "#7EB3F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.512 60H52.4879C51.6662 60 51 60.6662 51 61.4879V62.5121C51 63.3338 51.6662 64 52.4879 64H129.512C130.334 64 131 63.3338 131 62.5121V61.4879C131 60.6662 130.334 60 129.512 60Z",
    fill: "#166BCD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.6035 111.488C45.6035 110.666 46.2697 110 47.0915 110H134.315C135.137 110 135.803 110.666 135.803 111.488V116.6H45.6035V111.488Z",
    fill: "#166BCD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39 115.888C39 115.067 39.6662 114.4 40.4879 114.4H140.911C141.733 114.4 142.399 115.067 142.399 115.888V121H39V115.888Z",
    fill: "#166BCD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.5847 69.8424C55.6561 68.2524 56.966 67 58.5576 67H61.4385C63.0301 67 64.34 68.2524 64.4114 69.8424L65.8584 102.072C65.9345 103.767 64.5815 105.182 62.8856 105.182H57.1105C55.4146 105.182 54.0616 103.767 54.1377 102.072L55.5847 69.8424Z",
    fill: "#7EB3F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.7175 69.8313C75.7946 68.2459 77.1025 67 78.6898 67H82.3063C83.8936 67 85.2015 68.2458 85.2786 69.8313L86.8463 102.061C86.9289 103.76 85.5742 105.182 83.8739 105.182H77.1222C75.4219 105.182 74.0672 103.76 74.1498 102.061L75.7175 69.8313Z",
    fill: "#7EB3F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.5847 69.8424C96.6561 68.2524 97.966 67 99.5576 67H102.438C104.03 67 105.34 68.2524 105.411 69.8424L106.858 102.072C106.935 103.767 105.581 105.182 103.886 105.182H98.1105C96.4146 105.182 95.0616 103.767 95.1377 102.072L96.5847 69.8424Z",
    fill: "#7EB3F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.585 69.8424C116.656 68.2524 117.966 67 119.558 67H122.438C124.03 67 125.34 68.2524 125.411 69.8424L126.858 102.072C126.935 103.767 125.581 105.182 123.886 105.182H118.111C116.415 105.182 115.062 103.767 115.138 102.072L116.585 69.8424Z",
    fill: "#7EB3F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52 107C52 104.992 53.6281 103.364 55.6364 103.364H64.3636C66.3719 103.364 68 104.992 68 107V107H52V107Z",
    fill: "#7EB3F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.998 107C72.998 104.992 74.6261 103.364 76.6344 103.364H85.3617C87.37 103.364 88.998 104.992 88.998 107V107H72.998V107Z",
    fill: "#7EB3F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.998 107C92.998 104.992 94.6261 103.364 96.6344 103.364H105.362C107.37 103.364 108.998 104.992 108.998 107V107H92.998V107Z",
    fill: "#7EB3F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.998 107C112.998 104.992 114.626 103.364 116.634 103.364H125.362C127.37 103.364 128.998 104.992 128.998 107V107H112.998V107Z",
    fill: "#7EB3F1"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 91,
    cy: 44,
    r: 5,
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_29963_370718"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 181,
    height: 148,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDepositAppIcon);
export default __webpack_public_path__ + "static/media/DepositAppIcon.f9a8ec90e90d5e738cb8c0fb08304eaa.svg";
export { ForwardRef as ReactComponent };